define('helper-component-getContentArray',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';


        if (!Array.isArray(arr) || typeof s !== 'string') {
            return [];
        }

        s = s.toLowerCase();

        return arr.filter(function (o) {
            return o.kind && o.kind.toLowerCase() === s;
        }).map(function (o) {
            return o.content;
        });
    };
});
